import { z } from "zod";

export const generalConfigurationSchema = z.object({
  policyAndTermsConsentDisabled: z.boolean().optional(),
  zeroValueOrderNotificationText: z.string(),
  payOnDeliveryMessageText: z.string(),
  hidePromoCodeBlock: z.boolean().optional(),
});
